import React from 'react';
import { Box, Text, HStack } from '@chakra-ui/react';
import { InfoIcon } from '@chakra-ui/icons';

/**
 * InfoMessage Component
 *
 * Displays informational messages with consistent styling.
 * Replaces the previous over-decorated emoji-laden info boxes.
 *
 * @param {ReactNode} children - The message content
 * @param {string} variant - The type of message (info, warning, success)
 */
function InfoMessage({ children, variant = 'info' }) {
  const styles = {
    info: {
      bg: 'background.shade2',
      color: 'theme.darkGray',
      borderColor: 'border.default',
    },
    warning: {
      bg: 'orange.50',
      color: 'orange.800',
      borderColor: 'orange.200',
    },
    success: {
      bg: 'green.50',
      color: 'green.800',
      borderColor: 'green.200',
    },
  };

  const currentStyle = styles[variant] || styles.info;

  return (
    <Box
      bg={currentStyle.bg}
      color={currentStyle.color}
      p={3}
      borderRadius="md"
      border="1px solid"
      borderColor={currentStyle.borderColor}
    >
      <HStack spacing={2} align="start">
        <InfoIcon boxSize={4} mt={0.5} />
        <Text fontSize="sm">{children}</Text>
      </HStack>
    </Box>
  );
}

export default InfoMessage;
